import axios from 'axios'
import { reset } from 'redux-form'
import { API_URL } from './index'
import { REQUEST_REPLIES, RECEIVE_REPLIES, REFRESH_REPLIES, ADD_REPLY, DELETE_REPLY } from '../constants/ActionTypes'

//= ===============================
// Fetch Multiple Replies Action
//= ===============================

const requestReplies = (comment_id) => {
	return {
		type: REQUEST_REPLIES,
		comment_id
	}
}

const receiveReplies = (comment_id, response) => {
	return {
		type: RECEIVE_REPLIES,
		comment_id,
		payload: response.data,
		receivedAt: Date.now()
	}
}

const fetchReplies = (report_id, comment_id) => {
	return dispatch => {
		dispatch(requestReplies(comment_id))
		let url = `${API_URL}/story/replies/` + report_id + `?cid=` + comment_id
		console.log("B: " + comment_id)
		axios.get(url)
		.then((response) => {
			dispatch(receiveReplies(comment_id, response))
		})
		.catch((error) => {
			console.log(error)	
		})
	}
}

const shouldFetchReplies = (state, comment_id) => {
	const replies = state.repliesById[comment_id]
	if (!replies) {
		return true
	} else if (replies.isFetching) {
		return false
	}
	return true
}

export const loadReplies = (report_id, comment_id) => (dispatch, getState) => {
	if (shouldFetchReplies(getState(), comment_id)) {
		return dispatch(fetchReplies(report_id, comment_id))
	}
}

const addingReply = (comment_id) => {
	return {
		type: ADD_REPLY,
		comment_id
	}
}

const deletingReply = (comment_id) => {
	return {
		type: DELETE_REPLY,
		comment_id
	}
}

//= ===============================
// API Comments Action
//= ===============================

export const addReply = (report_id, comment_id, data) => (dispatch, getState) => {
	let token = getState().auth.token
	let authorization = "Bearer " + token
	let headers = {headers:{'Content-Type':'application/json', 'Authorization': authorization}}
	
	let url = `${API_URL}/story/comment/` + report_id + `?type=reply`
	axios.post(url, data, headers)
	.then((response) => {
		dispatch(fetchReplies(report_id, comment_id))
		dispatch(reset('reply'))
	})
	.catch((error) => {
		console.log(error)
	})
}

export const deleteReply = (reply_id, report_id, comment_id) => (dispatch, getState) => {
	let token = getState().auth.token
	let authorization = "Bearer " + token
	let headers = {headers:{'Authorization': authorization}}
	
	let url = `${API_URL}/story/uncomment/` + reply_id
	axios.delete(url, headers)
	.then((response) => {
		dispatch(fetchReplies(report_id, comment_id))
	})
	.catch((error) => {
		console.log(error)
	})
}


// WEBPACK FOOTER //
// ./src/actions/replies.js